import React, { useState } from "react";
import GridTable from "pages/_components/GridTable/GridTable";
import Accordion from "pages/_components/Accordion";
import { arrayOf, shape, string } from "prop-types";
import Button from "pages/_components/Button";
import * as i18n from "util/i18n";
import FirmasEcheck from "./_components/FirmasEcheck";
import EndososEcheck from "./_components/EndososEcheck";
import CesionEcheck from "./_components/CesionEcheck";
import RechazoEcheck from "./_components/RechazoEcheck";
import AvalEcheck from "./_components/AvalEcheck";
import AccordionItem from "pages/_components/AccordionItem";

const EcheckAccordion = ({ labels, data, numberToExpand, handleExpandEndorsement, curency }) => {
    const [isExpandAllSelected, setIsExpandAllSelected] = useState(false);
    const getTableData = (label, tableData) => {
        switch (label) {
            case "sign":
                return tableData?.map((firma) => <FirmasEcheck data={firma} />);
            case "aval":
                return tableData?.map((aval) => <AvalEcheck data={aval} curency={curency} />);
            case "endorse":
                // eslint-disable-next-line no-case-declarations
                const endorses = tableData?.filter((endoso) => endoso.emisor_documento !== endoso.benef_documento);

                if (endorses?.length > 0) {
                    return endorses?.map((endoso) => <EndososEcheck data={endoso} />);
                }
                return <div>{i18n.get("echecks.accordion.noData")}</div>;

            case "reject":
                return tableData?.map((rechazo) => <RechazoEcheck data={rechazo} />);
            case "cession":
                return tableData?.map((cesion) => <CesionEcheck data={cesion} />);
            default:
                return null;
        }
    };

    const handleExpandAll = () => {
        setIsExpandAllSelected((prevState) => !prevState);
    };
    return (
        <>
            <Accordion expandAll={isExpandAllSelected} numberToExpand={numberToExpand}>
                {labels.map((label, index) => (
                    <AccordionItem
                        key={label}
                        number={index}
                        toggleAccordion={handleExpandEndorsement}
                        item={
                            <span>
                                <span>{i18n.get(`echecks.accordion.${label}`)}</span>
                            </span>
                        }>
                        <GridTable className="information">
                            {data[label]?.length ? (
                                getTableData(label, data[label])
                            ) : (
                                <div>{i18n.get("echecks.accordion.noData")}</div>
                            )}
                        </GridTable>
                    </AccordionItem>
                ))}
            </Accordion>

            <Button
                label={!isExpandAllSelected ? "echecks.detail.expandAll" : "echecks.detail.collapseAll"}
                bsStyle="link"
                onClick={handleExpandAll}
                className="more-button"
            />
        </>
    );
};

EcheckAccordion.propTypes = {
    labels: arrayOf().isRequired,
    data: arrayOf(shape({})).isRequired,
    numberToExpand: string.isRequired,
    handleExpandEndorsement: string.isRequired,
    curency: string.isRequired,
};

export default EcheckAccordion;
